"use strict";

exports.__esModule = true;
exports["default"] = clearFix;

function clearFix(parent) {
  var _ref;

  if (parent === void 0) {
    parent = '&';
  }

  var pseudoSelector = parent + "::after";
  return _ref = {}, _ref[pseudoSelector] = {
    clear: 'both',
    content: '""',
    display: 'table'
  }, _ref;
}

module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./~/polished/lib/mixins/clearFix.js
// module id = 1021
// module chunks = 27180705640166